import React from 'react';
import classNames from 'classnames';

import css from './NavigationIcon.module.css';

// Account artwork: Lucide circle-user-round (ISC).
// Source: https://github.com/lucide-icons/lucide/blob/main/icons/circle-user-round.svg
// License distributed in public/static/licenses/lucide.txt.

/** Decorative navigation symbols; each containing control provides its accessible name. */
const NavigationIcon = ({ variant, className }) => (
  <svg
    className={classNames(css.root, className)}
    width="22"
    height="22"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={variant === 'account' ? 2 : 1.8}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    focusable="false"
  >
    {variant === 'account' ? (
      <>
        <path d="M17.925 20.056a6 6 0 0 0-11.851.001" />
        <circle cx="12" cy="11" r="4" />
        <circle cx="12" cy="12" r="10" />
      </>
    ) : variant === 'inbox' ? (
      <path d="M20 11.5a8 8 0 0 1-8 8H8l-5 2v-7a8 8 0 1 1 17-3Z" />
    ) : (
      <path d="M12 5v14M5 12h14" />
    )}
  </svg>
);

export default NavigationIcon;
